import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const PublicFaq = ({ items }) => {
  const [open, setOpen] = useState(0);

  return (
    <div className="overflow-hidden rounded-2xl border border-white/10 bg-white/5">
      <p className="px-5 pt-4 text-xs font-semibold uppercase tracking-[0.16em] text-primary-200">
        Perguntas frequentes
      </p>
      <ul className="divide-y divide-white/10">
        {items.map((item, idx) => {
          const expanded = open === idx;
          return (
            <li key={item.q}>
              <button
                type="button"
                className="flex w-full items-start justify-between gap-3 px-5 py-3 text-left text-sm font-semibold text-white"
                aria-expanded={expanded}
                onClick={() => setOpen(expanded ? -1 : idx)}
              >
                {item.q}
                <ChevronDown
                  className={`mt-0.5 h-4 w-4 shrink-0 text-primary-200 transition ${expanded ? 'rotate-180' : ''}`}
                  aria-hidden
                />
              </button>
              {expanded ? (
                <p className="px-5 pb-4 text-sm leading-relaxed text-slate-300">{item.a}</p>
              ) : null}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default PublicFaq;
